import { React } from "react";
import { useTranslation } from "react-i18next";
import { useAdvanceSearchContext } from "../AdvanceSearchContextTest";
import YearsOFExperience from "../components/YearsOfExperience";
import SeniorityLevel from "../components/SeniorityLevel";
import MainActivities from "../components/MainActivities";
import PersonalCharacteristics from "../components/PersonalCharacteristics";
import PersonalProfile from "../components/PersonalProfile";
import Comments from "../components/Comments";
import { ValidateFields } from "../ValidateFields";
import { Row } from "react-bootstrap";

export function Work({ changeCardStatus, cardStatus }) {
  const { t } = useTranslation();
  const { searchObject, setSearchObject, onChange } = useAdvanceSearchContext();

  function clearWork() {
    searchObject.seniorityLevels = [];
    searchObject.yearsOfExperienceOptions = [];
    searchObject.mainActivities = undefined;
    searchObject.personnalCharacteristics = undefined;
    searchObject.personalProfile = undefined;
    searchObject.comments = undefined;

    setSearchObject({
      ...searchObject
    });
  }

  return (
    <>
      <div className="accordion-item border-accordion">
        <h2
          className="accordion-header margin-accordion"
          id="headingCompetence"
        >
          <button
            className={`accordion-button border-accordion-button ${
              cardStatus ? "" : "collapsed heding-bold"
            }`}
            type="button"
            data-bs-target="#collapseCvs"
            aria-expanded="true"
            aria-controls="collapseCvs"
            onClick={changeCardStatus}
            id="accordionWork"
          >
            {`${t("Work")} ${ValidateFields.work(searchObject)}`}
          </button>
        </h2>
        <div
          id="accordionInputs"
          className={`accordion-collapse ${cardStatus ? "" : "collapse"}`}
          aria-labelledby="headingCompetence"
          data-bs-parent="#accordionFlushDocuments"
        >
          <div className="accordion-body table-wrap ">
            <Row>
              <div className="col-md-4">
                <SeniorityLevel
                  searchObject={searchObject}
                  setSearchObject={setSearchObject}
                  t={t}
                />
              </div>
              <div className="col-md-4">
                <YearsOFExperience
                  searchObject={searchObject}
                  setSearchObject={setSearchObject}
                  t={t}
                />
              </div>
            </Row>
            <Row className="margin-between-lables">
              <div className="col-md-4">
                <MainActivities
                  searchObject={searchObject}
                  onChange={onChange}
                  t={t}
                />
              </div>
              <div className="col-md-4">
                <PersonalCharacteristics
                  searchObject={searchObject}
                  onChange={onChange}
                  t={t}
                />
              </div>
            </Row>
            <Row className="margin-between-lables">
              <div className="col-md-4">
                <PersonalProfile
                  searchObject={searchObject}
                  onChange={onChange}
                  t={t}
                />
              </div>
              <div className="col-md-4">
                <Comments
                  searchObject={searchObject}
                  onChange={onChange}
                  t={t}
                />
              </div>
            </Row>
          </div>
          <div
            className="text-end button-clear-position"
            style={{ marginTop: "-10px" }}
          >
            <button
              className="app-button btn-second btn-md"
              onClick={clearWork}
            >
              {t("Clear Work")}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
